import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Cookie Policy</h1>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">What are cookies?</h2>
            <p className="text-gray-600 mb-6">
              Cookies are small text files that are stored on your computer or mobile device when you visit a website.
              They help us provide you with a better experience by remembering your preferences and improving site functionality.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Types of cookies we use</h2>

            <h3 className="text-xl font-semibold text-gray-700 mb-3">Essential Cookies</h3>
            <p className="text-gray-600 mb-4">
              These cookies are necessary for the website to function properly. They enable core functionality
              such as security, network management, and accessibility. You cannot disable these cookies.
            </p>

            <h3 className="text-xl font-semibold text-gray-700 mb-3">Analytics Cookies</h3>
            <p className="text-gray-600 mb-4">
              These cookies help us understand how visitors interact with our website by collecting and
              reporting information anonymously. This helps us improve our website and your experience.
            </p>

            <h3 className="text-xl font-semibold text-gray-700 mb-3">Marketing Cookies</h3>
            <p className="text-gray-600 mb-4">
              These cookies are used to deliver personalized advertisements that are more relevant to you.
              They may also be used to limit the number of times you see an advertisement.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Managing cookies</h2>
            <p className="text-gray-600 mb-4">
              You can control and manage cookies in various ways. Please note that removing or blocking
              cookies can impact your user experience and parts of our website may no longer be fully accessible.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Third-party cookies</h2>
            <p className="text-gray-600 mb-4">
              We may use third-party services that also set cookies on your device. These services include
              analytics providers, advertising networks, and social media platforms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact us</h2>
            <p className="text-gray-600 mb-4">
              If you have any questions about our use of cookies, please contact us through our support channels.
            </p>

            <p className="text-sm text-gray-500 mt-8">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;